import { render } from "./ForjaCelebrimborView.vue?vue&type=template&id=abfab14c&scoped=true"
import script from "./ForjaCelebrimborView.vue?vue&type=script&lang=js"
export * from "./ForjaCelebrimborView.vue?vue&type=script&lang=js"

import "./ForjaCelebrimborView.vue?vue&type=style&index=0&id=abfab14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abfab14c"]])

export default __exports__